module.exports = __webpack_public_path__ + "static/media/proj15_img10.1437f87c.jpg";